export default __webpack_public_path__ + "f809d4f304cb1ff1890698a64b6e9e0c.png";